import React from "react";

interface IProps {
    selected: boolean;
    value: number;
}

export default class AnimatedNumber extends React.Component<IProps> {
    public render(): JSX.Element {
        const { selected, value } = this.props;

        const classes = ["animated-number"];
        if (selected) {
            classes.push("selected");
        }

        return (
            <div className={ classes.join(" ") }>
                <span>{ value }</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnimatedNumber.tsx